module.exports = __webpack_public_path__ + "img/qrcode_image.07d10add.png";